import React from "react";
import { FaExternalLinkAlt } from "react-icons/fa";

interface GoogleMapsDirectionProps {
  subject: string;
  city: string;
  state: string;
}

export const GoogleMapsDirection: React.FC<GoogleMapsDirectionProps> = ({
  subject,
  city,
  state,
}) => {
  // DC location data - keeping only what's needed for the map
  const dcLocation = {
    id: "dc-connecticut",
    name: "Street Lawyer Services DC",
    address1: "3400 Connecticut Avenue NW",
    city: "Washington",
    state: "DC",
    zip: "20008",
    googleMapsUrl: "https://maps.app.goo.gl/DQhaPDbq7MeR9c8V7",
  };

  return (
    <section className="flex flex-col items-center text-white h-full">
      <div className="w-full h-full">
        {/* Map Title */}
        <h3 className="text-cannabis-green-400 text-xl text-center lg:text-left font-bold mb-4">
          Directions to Our Dispensary
        </h3>

        {/* Large Map */}
        <div className="w-full h-[400px] relative rounded-lg overflow-hidden">
          <iframe
            title="Directions to Street Lawyer Services Washington DC"
            className="w-full h-full"
            frameBorder="0"
            src={`https://www.google.com/maps/embed/v1/directions?key=AIzaSyBFUIzxEwVOnNgLtjKbUi2sLhdw0EbdPjw&destination=${encodeURIComponent(
              dcLocation.address1 +
                " " +
                dcLocation.city +
                " " +
                dcLocation.state +
                " " +
                dcLocation.zip
            )}&origin=${encodeURIComponent(city)},${state}&mode=driving`}
            allowFullScreen
          />
        </div>

        {/* Open in Maps Button - Show on all screen sizes */}
        <div className="mt-4 flex justify-center lg:justify-end">
          <a
            href={dcLocation.googleMapsUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 px-4 py-2.5 bg-cannabis-green-500 text-cannabis-green-950 rounded-lg hover:bg-cannabis-green-400 transition-colors font-medium"
          >
            <FaExternalLinkAlt /> Open in Maps
          </a>
        </div>
      </div>
    </section>
  );
};
